"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var slider_1 = __importDefault(require("./slider"));
var carousel = function () {
    var plansSection = document.querySelector('.c-plansSec');
    var plans = plansSection === null || plansSection === void 0 ? void 0 : plansSection.querySelector('.c-plansSec_swiper');
    if (!plans || !plansSection) {
        return;
    }
    var navWrapper = plansSection.querySelector('.c-plansSec .-nav');
    var navBtns = navWrapper === null || navWrapper === void 0 ? void 0 : navWrapper.querySelectorAll('button');
    var plansSwiper = (0, slider_1.default)({
        container: plans,
        options: {
            slidesPerView: 1,
            spaceBetween: 20,
            allowTouchMove: false,
        },
    });
    navBtns === null || navBtns === void 0 ? void 0 : navBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var slideIndex = parseInt(btn.dataset.slide || '0');
            var activeBtn = navWrapper === null || navWrapper === void 0 ? void 0 : navWrapper.querySelector('button.-active');
            plansSwiper.slideTo(slideIndex);
            activeBtn === null || activeBtn === void 0 ? void 0 : activeBtn.classList.remove('-active');
            btn.classList.add('-active');
        });
    });
};
carousel();
